'use client';

import { cn } from '@workspace/ui/lib';
import type { ReactNode } from 'react';

/** Shared surface styles for app top header icon buttons and the help desk pill. */
export const appTopHeaderActionSurfaceClassName =
  'bg-grey-100 text-neutral-200 dark:bg-grey-900 dark:text-neutral-100 hover:bg-grey-200 dark:hover:bg-grey-800 focus-visible:ring-primary cursor-pointer focus-visible:ring-2 focus-visible:outline-none';

interface AppTopHeaderProps {
  left?: ReactNode;
  organisationSwitcher?: ReactNode;
  helpDesk?: ReactNode;
  notifications?: ReactNode;
  profileMenu?: ReactNode;
  className?: string;
}

export function AppTopHeader({
  left,
  organisationSwitcher,
  helpDesk,
  notifications,
  profileMenu,
  className,
}: AppTopHeaderProps) {
  return (
    <div className={cn('flex min-h-[30px] w-full items-center justify-between gap-4', className)}>
      <div className="flex min-w-0 flex-1 items-center gap-3">{left}</div>

      <div className="flex shrink-0 items-center gap-3">
        {organisationSwitcher}
        {helpDesk}
        {notifications}
        {profileMenu}
      </div>
    </div>
  );
}
